import services from '../../../../services';
import * as types from './action-types';
import actions from '../action-creator';
const { pendingOffers, receivedOffers, fetchOffersAuthenticated } = actions;
import { getSimpleOffers } from '../util';

const api = services.coreAPIInstance;
const DEFAULT_RESPONSE = {
    getsQLDiscount: false,
    getsRLReturningClientDiscount: false,
    isTeamMember: false,
    getsCyberMondayDiscount: false,
    clientStateMinAmount: 0,
    customizedOffer: 0,
    maxOffer: 0,
};

function submit(requestedAmount) {
    return {
        asyncAction: (dispatch) => {
            dispatch(pendingOffers());
            return api.offers.customize(requestedAmount).then((res) => {
                res.data = res.data ? Object.assign({}, DEFAULT_RESPONSE, res.data) : res.data;
                dispatch(receivedOffers(res));
                return res;
            });
        },
        type: types.CUSTOMIZE_OFFERS,
    };
};

function submitAuthenticated(requestedAmount, loanId) {
    return {
        asyncAction: (dispatch) => {
            dispatch(pendingOffers());
            return api.offers.customizeAuthenticated(requestedAmount, loanId).then((res) => {
                var response = { data : getSimpleOffers(res), code: "OFFERS_RETRIEVED" };
                response.data ? Object.assign({}, DEFAULT_RESPONSE, response.data) : response.data;
                dispatch(fetchOffersAuthenticated({}, loanId));
                return response;
            });
        },
        type: types.CUSTOMIZE_OFFERS,
    };
};

export default {
    DEFAULT_RESPONSE,
    submitAuthenticated,
    submit
};
